

export function pull_level_array() {
  return {

    "PM2.5": [35, 45, 55, 65, 75, 115, 150, 250],
    PM10: [40, 70, 90, 120, 150, 250, 350, 420],
    SO2: [20, 50, 90, 120, 150, 475, 800, 1600],
    NO2: [40, 50, 60, 70, 80, 180, 280, 565],
    CO: [1, 2, 2.5, 3.5, 4, 14, 24, 36],
    O3: [100, 110, 120, 140, 160, 215, 265, 800],


    //        优  良+  良 良-  轻-------轻   重----重   严重
    // "PM2.5": [35, 50, 60, 75, 90, 100, 115, 130, 150, 250],
    // PM10: [50, 80, 110, 150, 180, 210, 250, 300, 350, 420],
    // SO2: [50, 80, 110, 150, 250, 350, 475, 600, 800, 1600],
    // NO2: [40, 50, 70, 80, 110, 140, 180, 230, 280, 565],
    // CO: [2, 2.5, 3.5, 4, 7, 10, 14, 20, 24, 36],
    // O3: [100, 120, 140, 160, 180, 200, 215, 235, 265, 800],


    // "PM2.5": [35, 75, 115, 150, 250],
    // PM10: [50, 150, 250, 350, 420],
    // SO2: [50, 150, 475, 800, 1600],
    // NO2: [40, 80, 180, 280, 565],
    // CO: [2, 4, 14, 24, 36],
    // O3: [100, 160, 215, 265, 800],
  }
}
export function get_pull_level(pull, value) {
  let levels = pull_level_array();

  let st = levels[pull];
  let level = 0;
  for (let i = 0; i < st.length; i++) {
    if (value <= st[i]) {
      level = i + 1;
      break;
    }
  }

  if (level == 0) {
    level = 1;
  }
  return level;
}

export function getPullStand(pull) {
  if (pull == "pm2_5" || pull == "PM2.5") {
    return "微克/立方米";
  } else if (pull == "pm10" || pull == "PM10") {
    return "微克/立方米";
  } else if (pull == "so2" || pull == "SO2") {
    return "微克/立方米";
  } else if (pull == "co" || pull == "CO") {
    return "毫克/立方米";
  } else if (pull == "no2" || pull == "NO2") {
    return "微克/立方米";
  } else if (pull == "o3" || pull == "o3") {
    return "微克/立方米";
  }

  return "微克/立方米";
}

export function getSeasonZH(season) {
  let seasonZh = ["春", "夏", "秋", "冬"];
  return seasonZh[season - 1];
}

export function getMonitorPulls(monitorIndex) {
  let pull1 = "";
  let pull2 = "";
  if (monitorIndex == 1) {
    pull1 = "PM2.5";
    pull2 = "PM10-2.5";
  } else if (monitorIndex == 2) {
    pull1 = "SO2";
    pull2 = "CO";
  } else if (monitorIndex == 3) {
    pull1 = "NO2";
    pull2 = "O3";
  }
  return [pull1, pull2];
}

// 简单的防抖动函数
export function debounce_simple(func, wait) {
  let timeout = null;  // 定时器变量
  return function () {
    let args = arguments;
    clearTimeout(timeout);  // 每次触发时先清除上一次的定时器,然后重新计时
    timeout = setTimeout(() => {
      func.apply(this, args)
    }, wait);  // 指定 xx ms 后触发真正想进行的操作 handler
  };
}

// 立即执行的防抖函数
export function debounce(func, wait = 500, immediate = true) {
  let timer, context, args

  // 延迟执行函数
  const later = () => setTimeout(() => {
    // 延迟函数执行完毕，清空缓存的定时器序号
    timer = null
    // 延迟执行的情况下，函数会在延迟函数中执行
    // 使用到之前缓存的参数和上下文
    if (!immediate) {
      func.apply(context, args)
      context = args = null
    }
  }, wait)

  // 这里返回的函数是每次实际调用的函数
  return function (...params) {
    // 如果没有创建延迟执行函数（later），就创建一个
    if (!timer) {
      timer = later()
      // 如果是立即执行，调用函数
      // 否则缓存参数和调用上下文
      if (immediate) {
        func.apply(this, params)
      } else {
        context = this
        args = params
      }
      // 如果已有延迟执行函数（later），调用的时候清除原来的并重新设定一个
      // 这样做延迟函数会重新计时
    } else {
      clearTimeout(timer)
      timer = later()
    }
  }
}


// 节流函数
export function throttle(fn, delay) {
  let timeout = null
  return function () {
    let args = arguments;
    if (!timeout) {
      timeout = setTimeout(() => {
        timeout = null
        fn.apply(this, args)
      }, delay)
    }
  }
}